<template>
    <div class="calligraphy-box">
        <div class="calligraphy-box-bg">
            <a href="#add"><el-button>立即咨询</el-button></a>
            <div class="calligraphy-box-common calligraphy-box-infor">
                <h3>专业介绍</h3>
                <p>书法是中国传统文化艺术发展五千年来最具有经典标志的民族符号。它是用毛笔书写汉字并具有审美惯性的艺术形式。书法堪称中国的“第四宗教”，有着强烈的吸引力、仪式感和大众参与性。技法上讲究执笔、用笔、点画、结构、墨法、章法等，与中国传统绘画、篆刻关系密切。<br> 主要培养方向为全国高等院校书法专业本科招生及全国各省书法专业统考，以独特的书法高考教学理念与教学方法，逐步形成了一定的办学规模，不断扩大在书法高考领域的影响力。</p>
            </div>
        </div> 
        <div class="calligraphy-box-work calligraphy-box-common">
            <h3>就业方向</h3>
            <el-row type="flex" class="calligraphy-box-work-list">
                <el-col v-for="(item,index) in workList" :key="index">
                    <img :src="item.src" alt="">
                    <h5>{{item.desc}}</h5>
                </el-col>
            </el-row>
        </div>
        <div class="calligraphy-box-tiao calligraphy-box-common calligraphy-box-common1">
            <h3>报考条件</h3>
            <h4>对专业感兴趣，有专研深入发展兴趣专业的决心，还要坚持学习</h4>
            <el-row class="calligraphy-box-tiao-content" type="flex" justify="space-between">
                <el-col v-for="(item,index) in tiaoList" :key="index">
                    <img :src="item.src" alt="">
                    <h5>{{item.desc}}</h5>
                </el-col>
            </el-row>
        </div>
        <div class="calligraphy-box-test calligraphy-box-common calligraphy-box-common1">
            <h3>考试内容</h3>
            <el-row class="calligraphy-box-test-content" type="flex" justify="space-between">
                <el-col v-for="(item,index) in testList" :key="index" :span="24">
                    <el-row>
                        <el-col :span="6">
                            <img :src="item.src">
                        </el-col>
                        <el-col :span="18">
                            <h5>{{item.title}}</h5>
                            <p>{{item.desc}}</p>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </div>
        <div class="calligraphy-box-subject calligraphy-box-common calligraphy-box-common1">
            <h3>学习科目</h3>
            <el-row class="calligraphy-box-subject-content" type="flex" justify="space-between">
                <el-col v-for="(item,index) in subjectList" :key="index">
                    <img :src="item.src" alt="">
                    <h5>{{item.desc}}</h5>
                </el-col>
            </el-row>
            <p>（每科满分 150分，总分 300 分）</p>
        </div>
        <div class="calligraphy-box-school calligraphy-box-common calligraphy-box-common1">
            <h3>推荐院校</h3>
            <el-row class="calligraphy-box-school-content" type="flex" justify="space-between">
                <el-col v-for="(item,index) in schoolList" :key="index">
                    <el-row>
                        <el-col :span="24">
                            <h5>{{item.title}}</h5>
                            <p>{{item.desc}}</p>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </div>
        <div class="calligraphy-box-order" id="add">
            <div class="calligraphy-box-order-content calligraphy-box-common calligraphy-box-common1">
                <h3>提交咨询表</h3>
                <h4>填写信息后，可以查询更多艺考信息</h4>
                <el-row>
                    <el-form :inline="true" :model="formInline" class="order-form-inline" :rules="rules" ref="formInline">
                        <el-form-item label="姓名：" prop="username">
                            <el-input v-model="formInline.username" placeholder="请输入姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="电话：" prop="phone">
                            <el-input v-model="formInline.phone" placeholder="请输入电话"></el-input>
                        </el-form-item>
                        <el-form-item label="专业：" prop="major">
                            <el-input v-model="formInline.major" placeholder="请输入专业"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="addSubscribeHandler" v-click-with-auth-login>提交</el-button>
                        </el-form-item>
                        </el-form>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
import { addSubscribe } from '@/api/user'
export default {
    data() {
        const validateUsername = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入姓名"));
            } else {
                callback();
            }
        };
        const validatePhone = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入电话"));
                } else {
                if ((/^1[34578]\d{9}$/.test(value))) {
                    callback();
                } else {
                    callback(new Error("请输入正确的电话"));
                }
            }
        };
        const validateMajor = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入专业"));
            } else {
                callback();
            }
        };
        return {
            workList:[
                {src:require('../../assets/images/calligraphy-work-icon1.jpg'),desc:'文化宫'},
                {src:require('../../assets/images/calligraphy-work-icon2.jpg'),desc:'博物馆'},
                {src:require('../../assets/images/calligraphy-work-icon3.jpg'),desc:'艺术馆'},
                {src:require('../../assets/images/calligraphy-work-icon4.jpg'),desc:'书法家'},
                {src:require('../../assets/images/calligraphy-work-icon5.jpg'),desc:'教育教学'},
                {src:require('../../assets/images/calligraphy-work-icon6.jpg'),desc:'报社'},
                {src:require('../../assets/images/calligraphy-work-icon7.jpg'),desc:'电视台'},
                {src:require('../../assets/images/calligraphy-work-icon8.jpg'),desc:'出版社'},
            ],
            tiaoList:[
                {src:require('../../assets/images/calligraphy-tiao-icon1.jpg'),desc:'无色盲、色弱'},
                {src:require('../../assets/images/calligraphy-tiao-icon2.jpg'),desc:'热爱书法'},
                {src:require('../../assets/images/calligraphy-tiao-icon3.jpg'),desc:'有良好的观察力与表现力'},
            ],
            testList:[
                {src:require('../../assets/images/calligraphy-test-icon1.jpg'),desc:'楷书和隶书各 1 幅。',title:'古代碑帖临摹'},
                {src:require('../../assets/images/calligraphy-test-icon2.jpg'),desc:'历代经典诗词（40 字以下，自选书体）要求：无论是古代碑帖临摹还是书法创作，皆竖式书写，充分利用纸面，章法完整协调、字体大小合适、字序准确、不漏字错字。临摹要求形神兼备，点画生动，考生基本功扎实；创作除上述要求外，要求布白合理，有较高的笔墨把控能力，能充分反映考生的艺术个性与审美追求。有繁体的字须使用繁体字，落款不得书写与规定内容无关的字，不得钤盖印章。',title:'书法创作'},
            ],
            subjectList:[
                {src:require('../../assets/images/calligraphy-subject-icon1.png'),desc:'古代碑帖临摹'},
                {src:require('../../assets/images/calligraphy-subject-icon2.png'),desc:'书法创作'},
            ],
            schoolList:[
                {title:'书法艺考艺术类院校：',desc:'中央美术学院(211)、中国美术学院、天津美术学院、鲁迅美术学院、四川美术学院、湖北美术学院、西安美术学院、山东工艺美术学院、南京艺术学院、广西艺术学院、云南艺术学院、吉林艺术学院、山东艺术学院、广州美术学院、河北美术学院(民办)'},
                {title:'书法艺考综合类院校：',desc:'暨南大学(211.985)、西安交通大学(211.985)、郑州大学(211.省部共建)、中央财经大学(211)、西安工业大学、河北大学、临沂大学、贵州民族大学、安徽宿州学院、黑河学院、宜春学院、保定学院、内蒙古呼伦贝尔学院、齐鲁理工学院、绍兴文理学院(兰亭书法艺术学院)、内蒙古科技大学(2016年新增)、北京语言大学、聊城大学、山西大同大学、云南昭通学院、河南大学、许昌学院、北京城市学院(民办)、南京师范大学泰州学院(独立学院)、西安交通大学城市学院(独立学院)、肇庆学院'},
                {title:'书法艺考师范类院校：',desc:'北京师范大学(211.985)、江苏师范大学(省部共建)、云南师范大学(省部共建)、河北师范大学、曲阜师范大学、海南师范大学、淮北师范大学、哈尔滨师范大学、杭州师范大学、西北师范大学、长春师范大学、贵州师范大学、广西师范大学、咸阳师范学院、鞍山师范学院、岭南师范学院(原湛江师范学院)、广西师范学院、淮阴师范学院、湖北师范学院、齐鲁师范学院、洛阳师范学院、湖南第一师范学院、上饶师范学院、洛阳师范学院、太原师范学院、廊坊师范学院、长沙师范学院、云南楚雄师范学院、安阳师范学院、玉溪师范学院、湖南人文科技学院、曲靖师范学院、河北师范大学汇华学院(独立学院)、首都师范大学科德学院(独立学院)'},
            ],
            formInline: {
                username: '',
                phone: '',
                major: '',
                type: '12'
            },
            rules: {
                username: [
                    { trigger: 'blur', validator: validateUsername },
                ],
                phone: [
                    { trigger: 'blur', validator: validatePhone },
                ],
                major: [
                    { trigger: 'blur', validator: validateMajor },
                ],
            }
        };
    },
    methods: {
        addSubscribeHandler() {
            let that = this;
            this.$refs.formInline.validate((valid) => {
                if(valid) {
                    addSubscribe(that.formInline).then(res => {
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                    })
                }
            })
        }
    },
};
</script>

<style lang="scss" scoped>
$font-family: 'MicrosoftYaHei';
$width: 1200px;
$margin: 0 auto;
.calligraphy-box-common {
    padding-top: 62px;
    box-sizing: border-box;
    h3 {
        font-size: 36px;
        font-family: $font-family;
        font-weight: 700;
        text-align: center;
        color: #332e2c;
        line-height: 47px;
        letter-spacing: 3.6px;
        margin: 0;
    }
}
.calligraphy-box-common1 {
    >h4 {
        font-size: 18px;
        font-family: $font-family;
        font-weight: 400;
        text-align: center;
        color: rgba(255,255,255,0.60);
        line-height: 24px;
        margin: 27px 0 62px 0;
    }
}
.calligraphy-box-bg {
    background: url('../../assets/images/calligraphy-bg.jpg') no-repeat center;
    background-size: cover;
    width: 100%;
    height: 644px;
    button {
        width: 136px;
        height: 50px;
        background: rgba(204,156,100,0.20)!important;
        border: 1px solid #cc9c64!important;
        border-radius: 8px;
        font-size: 18px;
        font-weight: 400;
        color: #cc9c64;
        position: relative;
        left: calc(50% - 600px);
        top: 320px;
    }
    button:hover {
        background: rgba(204,156,100,0)!important;
    }
}
.calligraphy-box-infor {
    width: $width;
    margin: $margin;
    height: 361px;
    background: rgba(255,255,255,0.90);
    border-radius: 20px;
    box-shadow: 0px 4px 20px 0px rgba(143,43,0,0.12), 0px 1.5px 0px 0px rgba(255,255,255,0.56) inset; 
    backdrop-filter: blur(4px);
    padding: 44px 58px;
    margin-top: 400px;
    p {
        font-size: 20px;
        font-family: $font-family;
        font-weight: 400;
        color: #2c3331;
        line-height: 38px;
        margin-top: 36px;
    }
}
.calligraphy-box-work {
    padding-top: 225px;
    height: 570px;
    background: #f5f7fa;
    box-sizing: border-box;
    .calligraphy-box-work-list {
        width: $width;
        margin: $margin;
        // align-content:space-between;
        // flex-flow: row wrap;
        flex-wrap: wrap;
        margin-top: 58px;
    }
    .el-col:not(:nth-child(8n)) {
        margin-right: 22px;
    }
    .el-col {
        width: 130px;
        text-align: center;
        h5 {
            margin-top: 16px;
            font-size: 20px;
            font-family: $font-family;
            font-weight: 400;
            text-align: center;
            color: #2c3331;
            line-height: 26px;
            margin-bottom: 32px;
        }
    }
}
.calligraphy-box-tiao {
    height: 509px;
    background: url('../../assets/images/broadcast-tiao-bg.jpg') no-repeat center;
    background-size: cover;
    position: relative;
    padding-top: 52px;
    h3 {
        color: #ffffff;
    }
    h4 {
        margin: 20px 0 52px 0;
    }
    .calligraphy-box-tiao-content {
        width: $width;
        margin: 0 auto;
        flex-wrap: wrap;
        margin-top: 4px;
        .el-col {
            width: 376px;
            height: 228px;
            position: relative;
            margin-bottom: 40px;
        }
        img {
            border-radius: 20px;
        }
        h5 {
            // padding: 0 30px;
            margin: 0;
            font-size: 18px;
            position: absolute;
            font-family: $font-family;
            font-weight: 400;
            text-align: center;
            color: #ffffff;
            line-height: 60px;
            text-align: center;
            height: 60px;
            background: rgba(204,156,100,0.80);
            border-radius: 0px 0px 20px 20px;
            bottom: 0px;
            width: 100%;
        }
    }
}
.calligraphy-box-test {
    background: url('../../assets/images/common-test.jpg') no-repeat center;
    background-size: cover;
    width: 100%;
    height: 627px;
    h4 {
        color: #999999;
    }
    .calligraphy-box-test-content {
        width: $width;
        margin: $margin;
        flex-wrap: wrap;
        margin-top: 48px;
        .el-col-24 {
            margin-bottom: 38px;
            h5 {
                font-size: 26px;
                font-family: $font-family;
                font-weight: 700;
                text-align: left;
                color: #332e2c;
                line-height: 35px;
                margin: 0;
                margin-left: 10px;
            }
            p{
                font-size: 18px;
                font-family: $font-family;
                font-weight: 400;
                text-align: left;
                color: #66605e;
                line-height: 32px;
                margin: 0;
                margin-left: 10px;
                margin-top: 17px;
            }
        }
    }
}
.calligraphy-box-subject {
    width: 100%;
    height: 531px;
    background: #cd8838;
    h3 {
        color: #fff;
    }
    p {
        font-size: 18px;
        font-family: $font-family;
        font-weight: 400;
        text-align: center;
        color: rgba(255,255,255,0.60);
        line-height: 24px;
        margin: 0;
    }
    .calligraphy-box-subject-content {
        width: $width;
        margin: $margin;
        flex-wrap: wrap;
        margin-top: 56px;
        .el-col {
            width: 50%;
            text-align: center;
            h5 {
                font-size: 20px;
                font-family: $font-family;
                font-weight: 400;
                text-align: center;
                color: #ffffff;
                line-height: 26px;
                margin: 24px 0 40px 0;
            }
        }
    }
}
.calligraphy-box-school {
    height: 939px;
    background: url('../../assets/images/director-school-bg.jpg') no-repeat center;
    background-size: cover;
    width: 100%;
    h3 {
        color: #fff;
    }
    .calligraphy-box-school-content {
        width: $width;
        margin: $margin;
        flex-wrap: wrap;
        margin-top: 22px;
        h5 {
            width: 268px;
            height: 58px;
            background: #db9748;
            border-radius: 8px;
            margin: 0;
            font-size: 24px;
            font-family: $font-family;
            font-weight: 700;
            color: #ffffff;
            line-height: 58px;
            padding: 0 12px;
            box-sizing: border-box;
            margin: 32px 0 16px 0;
        }
        p {
            font-size: 20px;
            font-family: $font-family;
            font-weight: 400;
            color: #ffffff;
            line-height: 38px;
            margin: 0;
        }
    }
}
.calligraphy-box-order {
    background: url('../../assets/images/common-bg.png') no-repeat;
    background-size: cover;
    background: #cd8838;
    height: 359px;
    margin-bottom: -56px;
    h3 {
        color: #fff;
    }
    h4 {
        margin-bottom: 55px;
    }
    .calligraphy-box-order-content {
        width: $width;
        margin: $margin;
        .order-form-inline {
            margin-top: 0;
        }
        span {
            display: inline-block;
        }
        img {
            position: absolute;
            top:0;
            left: 0;
        }
        .calligraphy-box-order-title {
            font-size: 36px;
            font-family: 'zihun443hao';
            color: #ffffff;
        }
        .calligraphy-box-order-desc {
            font-size: 18px;
            font-weight: 500;
            color: #ffffff;
            margin-left: 24px;
        }
    }
}
</style>